import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { isArray } from 'util';
import { environment } from '../../../../environments/environment';
// tslint:disable-next-line: max-line-length
import { EditModelMaintenanceTaskConfigurationFormFileInterface } from '../../../dashboard/admin/machine/model/edit-model-maintenance-task-configuration/edit-model-maintenance-task-configuration-form/edit-model-maintenance-task-configuration-form-pdf/edit-model-maintenance-task-configuration-form-file.interface';
// tslint:disable-next-line: max-line-length
import { EditModelMaintenanceTaskConfigurationFormInterface } from '../../../dashboard/admin/machine/model/edit-model-maintenance-task-configuration/edit-model-maintenance-task-configuration-form/edit-model-maintenance-task-configuration-form.interface';
import { MaintenanceTaskConfigurationBuilder } from '../../models/builders/maintenance-task-configuration.builder';
import { Role } from '../../models/role';
import { valueOf } from '../../utils/string.utils';

const getUpdateFiles = (file: EditModelMaintenanceTaskConfigurationFormFileInterface[]) => {
  return (isArray(file))
    ? file.map(image => ({
      hash: image.hash ? image.hash : null,
    }))
    : [];
};

const createRoleBody = (roles: Role[]) => {
  return (isArray(roles))
    ? roles.map(role => ({
      hash: role.code ? role.code : null,
    }))
    : [];
};

const getUpdatedConfigurationBody = (data: EditModelMaintenanceTaskConfigurationFormInterface) => {
  const postBody = new FormData();
  postBody.append('modelHash', data.modelHash);
  postBody.append('name', data.name);
  postBody.append('frequencyInDays', valueOf(data.frequencyInDays));
  postBody.append('duration', valueOf(data.duration));
  postBody.append('hours', valueOf(data.hours));
  postBody.append('startDate', valueOf(data.startDate));
  if (data.pdfs) {
    postBody.append('pdfs', JSON.stringify(getUpdateFiles(data.pdfs)));
  }
  if (data.newPDFs) {
    for (let i = 0; i < data.newPDFs.length; i++) {
      postBody.append('newPdfs', data.newPDFs[i]);
    }
  }
  if (data.roles) {
    postBody.append('roles', JSON.stringify(createRoleBody(data.roles)));
  }

  return postBody;
};


const getCreatedConfigurationBody = (data: EditModelMaintenanceTaskConfigurationFormInterface) => {
  const postBody = new FormData();
  postBody.append('modelHash', data.modelHash);
  postBody.append('name', data.name);
  postBody.append('frequencyInDays', valueOf(data.frequencyInDays));
  postBody.append('duration', valueOf(data.duration));
  postBody.append('hours', valueOf(data.hours));
  postBody.append('startDate', valueOf(data.startDate));
  if (data.newPDFs) {
    for (let i = 0; i < data.newPDFs.length; i++) {
      postBody.append('pdfs', data.newPDFs[i]);
    }
  }
  if (data.roles) {
    postBody.append('roles', JSON.stringify(createRoleBody(data.roles)));
  }


  return postBody;
};

@Injectable()
export class MaintenanceTaskConfigurationApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}maintenance-task-configurations`;
  }

  getMaintenanceTaskConfigurationsByModel(modelHash) {
    const params = new HttpParams().append('modelHash', modelHash);

    return this.httpClient
      .get(this.apiUrl, { params })
      .pipe(map(MaintenanceTaskConfigurationBuilder.fromList));
  }

  deleteMaintenanceTaskConfiguration(hash) {
    return this.httpClient.delete(`${this.apiUrl}/${hash}`);
  }

  getMaintenanceTaskConfiguration(hash) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(map(MaintenanceTaskConfigurationBuilder.fromJson));
  }

  updateMaintenanceTaskConfiguration(data: EditModelMaintenanceTaskConfigurationFormInterface) {
    return this.httpClient
      .post(
        `${this.apiUrl}/${data.hash}`,
        getUpdatedConfigurationBody(data)
      )
      .pipe(map(MaintenanceTaskConfigurationBuilder.fromJson));
  }

  createMaintenanceTaskConfiguration(data: EditModelMaintenanceTaskConfigurationFormInterface) {
    return this.httpClient
      .post(
        `${this.apiUrl}`,
        getCreatedConfigurationBody(data)
      )
      .pipe(map(MaintenanceTaskConfigurationBuilder.fromJson));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/maintenance-task-configuration-api.service.ts